<template>
    <div class="banner" :class="{'hot2': isHotSale }" :style="{width: pageWidth+'px'}">
        <van-swipe :autoplay="3000" indicator-color="#ff7a45" :style="{height: pageWidth+'px'}">
            <van-swipe-item v-for="(item, index) in imgUrlList" :key="index" :style="{height: pageWidth+'px'}" class="banner-parent">
                <img v-lazy="$viewImageNew(item, 600,600)" class="banner-item" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
export default {
    props: {
        pageWidth: {
            type: Number,
            default: 320
        },
        imgUrlList: {
            type: Array,
            default: () => {
                return []
            }
        },
        isHotSale: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang='scss' scoped>
    .banner {
        height: 100vw;
        position: relative;
        .banner-item {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    /deep/ .mint-swipe-indicator {
        width: 14px;
        height: 14px;
        margin: 10px;
        border-radius: 50%;
    }
</style>